import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../config/axiosClient";
import UserContext from "../context/UserContext";

const Login = () => {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  // --- State for Password Reset ---
  const [showReset, setShowReset] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [otp, setOtp] = useState(""); 
  const [newPassword, setNewPassword] = useState(""); 
  const [resetMsg, setResetMsg] = useState({ type: "", text: "" });
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1); 

  // ✅ Login Handling
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axiosClient.post("/auth/login", { userName, password });
      
      const token = res.data.token;
      const roleFromServer = res.data.role || res.data.Role || ""; 
      const idFromServer = res.data.id || res.data.userId || ""; 

      const userData = { 
        userName, 
        token: token,
        role: roleFromServer,
        id: idFromServer,
        userId: idFromServer
      };

      localStorage.setItem("token", token);

      // ✅ FIX QUAN TRỌNG: lưu userId để TaskDailyList dùng
      localStorage.setItem("userId", idFromServer);

      setUser(userData);

      console.log(">>> Login Success - Unified ID:", idFromServer);
      navigate("/attendance"); 

    } catch (err) {
      const msg = err.response?.data;
      setError(
        msg === "User is locked" || msg === "User is inactive" 
          ? "Account is locked or inactive" 
          : (msg || "Login failed")
      );
    }
  };

  // STEP 1: Send OTP Request
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResetMsg({ type: "info", text: "Checking and sending OTP..." });
    try {
      await axiosClient.post("/auth/send-otp", { emailOrUser: resetEmail });
      setResetMsg({ type: "success", text: "OTP sent! Please check your email." });
      setStep(2); 
    } catch (err) {
      setResetMsg({ type: "danger", text: err.response?.data || "Error sending OTP" });
    } finally {
      setLoading(false);
    }
  };

  // STEP 2: Confirm OTP & Reset Password
  const handleConfirmReset = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axiosClient.post("/auth/reset-password-otp", { 
        emailOrUser: resetEmail, 
        otp: otp,
        newPassword: newPassword 
      });
      
      setResetMsg({ type: "success", text: "Password reset successful!" });
      
      setTimeout(() => {
        handleCloseModal();
      }, 2000);
    } catch (err) {
      setResetMsg({ type: "danger", text: err.response?.data || "Incorrect OTP" });
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowReset(false);
    setResetMsg({ type: "", text: "" });
    setResetEmail("");
    setOtp("");
    setNewPassword("");
    setStep(1);
  };

  return (
    <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "#4e73df", fontFamily: "'Nunito', sans-serif" }}>
      <div className="card shadow" style={{ width: "100%", maxWidth: "400px", borderRadius: "1rem", padding: "30px", backgroundColor: "#fff" }}>
        <div className="text-center mb-4">
          <img src="https://img.icons8.com/ios-filled/100/4e73df/login-rounded-right.png" alt="Login Icon" style={{ width: "70px", marginBottom: "15px" }} />
          <h3 style={{ color: "#4e73df", fontWeight: 700 }}>PEX System</h3>
          <p style={{ color: "#858796", fontSize: "0.9rem" }}>Sign in to continue</p>
        </div>

        {error && <div className="alert py-2 small text-center" style={{ backgroundColor: "#e74a3b", color: "#fff" }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <input type="text" className="form-control" placeholder="Username" value={userName} onChange={(e) => setUserName(e.target.value)} required style={{ borderRadius: "10px", padding: "12px" }} />
          </div>
          <div className="mb-4">
            <input type="password" className="form-control" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required style={{ borderRadius: "10px", padding: "12px" }} />
          </div>
          <button type="submit" className="btn btn-success w-100 mb-3" style={{ backgroundColor: "#1cc88a", border: "none", borderRadius: "10px", padding: "12px", fontWeight: 700 }}>
            Login
          </button>
        </form>

        <div className="text-center border-top pt-3">
          <button onClick={() => { setShowReset(true); setResetEmail(userName); }} style={{ background: "none", border: "none", color: "#4e73df", fontSize: "0.85rem", fontWeight: 600, cursor: "pointer" }}>
            Reset Password?
          </button>
        </div>
      </div>

      {/* --- Forgot Password Modal --- */}
      {showReset && (
        <div style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.6)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }}>
          <div className="card p-4 shadow-lg" style={{ width: "380px", borderRadius: "15px" }}>
            <div className="text-center mb-3">
              <h5 style={{ color: "#4e73df", fontWeight: 700 }}>{step === 1 ? "Forgot Password?" : "OTP Verification"}</h5>
              <p className="small text-muted">{step === 1 ? "Enter your info to receive an OTP." : "Enter the OTP sent to your email."}</p>
            </div>
            
            {resetMsg.text && <div className={`alert alert-${resetMsg.type} py-1 small text-center`}>{resetMsg.text}</div>}
            
            <form onSubmit={step === 1 ? handleSendOtp : handleConfirmReset}>
              {step === 1 ? (
                <div className="mb-2">
                  <label className="small fw-bold">Username / Email</label>
                  <input type="text" className="form-control" placeholder="Enter username or email" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} required style={{borderRadius: "8px"}} />
                </div>
              ) : (
                <>
                  <div className="mb-2">
                    <label className="small fw-bold text-primary">OTP Code</label>
                    <input type="text" className="form-control text-center fw-bold" placeholder="6-digit code" value={otp} onChange={(e) => setOtp(e.target.value)} required style={{borderRadius: "8px", letterSpacing: "5px", fontSize: "1.2rem"}} />
                  </div>
                  <div className="mb-3">
                    <label className="small fw-bold">New Password</label>
                    <input type="password" className="form-control" placeholder="Enter new password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} required style={{borderRadius: "8px"}} />
                  </div>
                </>
              )}

              <div className="d-flex gap-2 mt-3">
                <button type="submit" disabled={loading} className="btn btn-primary w-100" style={{borderRadius: "10px"}}>
                  {loading ? "Processing..." : (step === 1 ? "Send OTP" : "Reset Password")}
                </button>
                <button type="button" className="btn btn-light w-100" style={{borderRadius: "10px"}} onClick={handleCloseModal}>Cancel</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;